import React from 'react';
import SlidingSideBar from '../../SlidingSideBar/SlidingSideBar';
import MockPrint from '../../doc-hub/MockPrint';

const CommissionSheetSidebar = ({ visible, onClose, inventory, appChoices }) => {
  return (
    <SlidingSideBar visible={visible} title="Commission Sheet" onClose={onClose} fullScreen showCloseButton>
      <div className="p-2 px-5">
        {visible && inventory && appChoices?.length > 0 && (
          <MockPrint
            key={inventory._id}
            appChoices={appChoices}
            documentName="Commission Sheet"
            initialInventoryUnit={inventory}
          />
        )}
      </div>
    </SlidingSideBar>
  );
};

export default CommissionSheetSidebar;
